import { FunctionComponent, lazy, Suspense } from 'react';

const Graph = lazy(() => import('./ThemeWrappedGraph'));

const LazyRoute: FunctionComponent = () => <Suspense fallback={null}><Graph /></Suspense>;

export default LazyRoute;
